// Honest legal content — no invented approvals, certifications, or regulatory claims.
export const LEGAL_DOCS = {
  privacy: {
    titleKey: "legal.privacy",
    body: {
      en: [
        "LUMORA is built to protect children and families. The core learning experience works without an account, and we do not require a crypto wallet to learn, play, or read.",
        "Your lesson, story, and game progress is stored only in your own browser (local storage) on your device. We do not upload it to our servers and we do not sell or share it.",
        "We do not knowingly collect unnecessary personal information from children. We avoid tracking that is not needed to run the site, and we never track wallet addresses for advertising.",
        "If privacy-conscious analytics are used, they are limited to understanding general site performance and never expose private learning progress.",
        "Questions about privacy can be directed to the project's official channels once published.",
      ],
      zh: [
        "LUMORA 的设计以保护儿童和家庭为宗旨。核心学习体验无需账号即可使用，学习、游玩或阅读都不需要加密钱包。",
        "你的课程、故事和游戏进度仅保存在你设备上的浏览器（本地存储）中。我们不会将其上传到服务器，也不会出售或分享。",
        "我们不会在明知的情况下收集儿童不必要的个人信息。我们避免任何运行网站所不需要的跟踪，也绝不为广告目的跟踪钱包地址。",
        "如果使用注重隐私的分析工具，其范围仅限于了解网站的总体表现，绝不会公开你的私人学习进度。",
        "有关隐私的问题，可在项目官方渠道发布后向其咨询。",
      ],
    },
  },
  terms: {
    titleKey: "legal.terms",
    body: {
      en: [
        "By using LUMORA you agree to use the site respectfully and for its intended educational purpose.",
        "Educational content is provided for general learning. It is offered in good faith but without any warranty of completeness or fitness for a particular purpose.",
        "Token-related information is informational only and is not an offer, solicitation, or financial advice.",
        "We may update features, content, and these terms over time. Continued use means you accept the current version.",
      ],
      zh: [
        "使用 LUMORA 即表示你同意以尊重的态度、按其教育用途使用本网站。",
        "教育内容用于一般学习目的。我们本着善意提供，但不对其完整性或特定用途的适用性作任何保证。",
        "与代币相关的信息仅供参考，不构成任何要约、招揽或投资建议。",
        "我们可能会不时更新功能、内容及本条款。继续使用即表示你接受当前版本。",
      ],
    },
  },
  disclaimer: {
    titleKey: "legal.disclaimer",
    body: {
      en: [
        "LUMORA's lessons, games, and stories are designed to support learning at home and in the classroom.",
        "We do not claim professional accreditation or educational certification. Content is a helpful starting point, not a substitute for a full curriculum or professional advice.",
        "Adults should supervise young children as appropriate, especially for online activities.",
      ],
      zh: [
        "LUMORA 的课程、游戏和故事旨在支持家庭与课堂中的学习。",
        "我们不声称拥有专业认证或教育资质。内容是有益的起点，不能替代完整课程或专业建议。",
        "成年人应酌情监护幼儿，尤其是在进行线上活动时。",
      ],
    },
  },
  risk: {
    titleKey: "legal.risk",
    body: {
      en: [
        "Any token participation involves significant financial risk, including the possible total loss of funds.",
        "Nothing on this website is financial, investment, legal, or tax advice.",
        "Token participation is entirely separate from — and never required for — access to LUMORA's free education.",
        "The token contract is not yet deployed. We will never display a fabricated contract address, supply, price, market cap, or audit status. We do not claim the token is audited unless a verifiable audit report exists.",
      ],
      zh: [
        "参与任何代币都涉及重大财务风险，包括可能的资金全部损失。",
        "本网站上的任何内容均不构成财务、投资、法律或税务建议。",
        "参与代币与获取 LUMORA 的免费教育完全分开，且从不作为前提条件。",
        "代币合约尚未部署。我们绝不会显示虚构的合约地址、供应量、价格、市值或审计状态。除非存在可验证的审计报告，否则我们不会声称代币已通过审计。",
      ],
    },
  },
  methodology: {
    titleKey: "legal.methodology",
    body: {
      en: [
        "LUMORA tracks charitable contributions through clearly separated stages: Planned, Awaiting verification, Pending, Confirmed, and Failed.",
        "Only confirmed on-chain transactions with a transaction hash and a public explorer link count as completed donations.",
        "We do not display projected figures as real-world results, and we do not imply a donation has occurred before it is confirmed.",
        "Until the token contract, treasury, and on-chain indexer are deployed, the Impact Dashboard shows a clearly labeled pre-launch state instead of simulated live metrics.",
        "Reports will explain conversion costs, network fees, and donation timing when real data exists.",
      ],
      zh: [
        "LUMORA 通过清晰分离的阶段跟踪慈善捐助：计划中、待核实、待处理、已确认和失败。",
        "只有带有交易哈希和公开区块链浏览器链接、已在链上确认的交易，才算作已完成的捐助。",
        "我们不会将预计数字当作真实结果展示，也不会在捐助确认前暗示捐助已经发生。",
        "在代币合约、金库和链上索引器部署之前，影响面板会显示明确标注的上线前状态，而非模拟的实时数据。",
        "当有真实数据时，报告将说明兑换成本、网络手续费和捐助时间。",
      ],
    },
  },
  copyright: {
    titleKey: "legal.copyright",
    body: {
      en: [
        "LUMORA only publishes content it owns or has permission to distribute.",
        "The LUMORA name, logo, mascots, and brand assets belong to the project and may not be reused without permission.",
        "If you believe content infringes your rights, please contact the project's official channels so it can be reviewed.",
      ],
      zh: [
        "LUMORA 只发布其拥有或已获授权分发的内容。",
        "LUMORA 的名称、标志、吉祥物及品牌素材均归本项目所有，未经许可不得再次使用。",
        "如果你认为某内容侵犯了你的权利，请通过项目官方渠道联系，以便进行审核。",
      ],
    },
  },
};

export const LEGAL_ORDER = ["privacy", "terms", "disclaimer", "risk", "methodology", "copyright"];
